<!-- 组件 -->
<template>
    <div class="sideBar">
        <div class="logo"><img src="../assets/logo.png"></div>
        <div class="menu">
            <ul>
                <li v-for="(silder, index) in silders" :key="index">
                    <router-link :to="silder.to" class="menu-item" :class="{ cur: $route.name === silder.to }"><i
                            :class="silder.icon"></i><span>{{ silder.name }}</span></router-link>
                </li>
                <!-- <li>
                    <span href="javascript:void(0)" @click="checkoutDialog = true"><i class="c-6"></i><span>退出系统</span></a>
                </li> -->
            </ul>
        </div>
        <div class="mgt5 xrow ai-c jc-c logout">
            <el-button round @click="checkoutDialog = true">退出系统</el-button>
        </div>
        <el-dialog :visible.sync="checkoutDialog" width="400px" append-to-body custom-class="hs-dialog" top="30vh">
            <div slot="title">
                系统提示
            </div>
            <span>您确定要退出系统吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkoutDialog = false">取 消</el-button>
                <el-button type="primary" @click="checkOut">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
/**
 *
 */
export default {
    name: 'sidebar',
    props: {},
    data() {
        return {
            checkoutDialog: false,
            silders: [
                {
                    to: 'home',
                    icon: 'c-1',
                    name: '首页'
                },
                {
                    to: 'log',
                    icon: 'c-2',
                    name: '运行日志'
                },
                // {
                //     to: 'message',
                //     icon: 'c-3',
                //     name: '消息通知'
                // },
                {
                    to: 'account',
                    icon: 'c-4',
                    name: '账户信息'
                },
                {
                    to: 'password',
                    icon: 'c-5',
                    name: '修改密码'
                }
            ]
        }
    },
    computed: {},

    mounted() {
        console.log(this.$route.name, this.$route.path)
        this.loadData()
    },

    methods: {
        loadData() { },
        checkOut(done) {
            this.checkoutDialog = false
            this.$store.commit('logout')
            this.$router.push({ name: 'login' })
        }
    }
}
</script>
<style lang='less' scoped>
.sideBar {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    overflow: hidden;
    background: #fff;
    z-index: 1000;
    width: 175px;
    border-right: 1px solid #f0f3f7;

    .logo {
        text-align: center;
        padding: 45px 0;

        img {
            width: 110px;
            height: 110px;
        }
    }
}

.menu {
    .menu-item {
        user-select: none;
        display: block;
        background-color: #fff;
        border-left: solid 6px #fff;
        height: 60px;
        line-height: 60px;
        padding-left: 20px;
        text-align: left;

        span {
            color: #1f2b4f;
            font-size: 14px;
            margin-left: 12px;
            display: inline-block;
            vertical-align: middle;
        }

        i {
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;

            &.c-1 {
                background: url('../assets/menu/c-1.png') no-repeat;
            }

            &.c-2 {
                background: url('../assets/menu/c-2.png') no-repeat;
            }

            &.c-3 {
                background: url('../assets/menu/c-3.png') no-repeat;
            }

            &.c-4 {
                background: url('../assets/menu/c-4.png') no-repeat;
            }

            &.c-5 {
                background: url('../assets/menu/c-5.png') no-repeat;
            }

            &.c-6 {
                background: url('../assets/menu/c-6.png') no-repeat;
            }
        }

        &.cur,
        &:hover {
            background-color: #e1faf1;
            border-left: solid 6px #3fcdae;

            span {
                color: #3fcdae;
                font-weight: bold;
            }

            .c-1 {
                background: url('../assets/menu/c-01.png') no-repeat;
            }

            .c-2 {
                background: url('../assets/menu/c-02.png') no-repeat;
            }

            .c-3 {
                background: url('../assets/menu/c-03.png') no-repeat;
            }

            .c-4 {
                background: url('../assets/menu/c-04.png') no-repeat;
            }

            .c-5 {
                background: url('../assets/menu/c-05.png') no-repeat;
            }

            .c-6 {
                background: url('../assets/menu/c-06.png') no-repeat;
            }
        }
    }
}

.hs-dialog {
    border-radius: 6px;
    overflow: hidden;

    .el-dialog__header {
        background: url(../assets/title_top.jpg) no-repeat;
        background-size: 100% 100%;
        padding: 10px 20px;

        .el-dialog__headerbtn {
            top: 15px;
        }
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 16px;
        font-weight: bold;
    }

    .hs-dialog-title {
        font-size: 18px;
        color: white;
    }
}

.logout {
    position: absolute;
    bottom: 50px;
    left: 37px;
}
</style>
